export const tableOption = {
  dialogDrag: true,
   border: true,
  indexLabel: "序号",
  height:"calc(100vh - 420px)",
  stripe: false,
  menuAlign: "center",
  align: "center",
  menuType: "text",
  searchShow: true,
  excelBtn: false,
  printBtn: false,
  defaultSort:{
    prop:'bindingDate',
    order:'descending'
  },
  viewBtn: false,
  searchBtn:false,
  emptyBtn:false,
  searchMenuSpan: 24,
  menuWidth:90,
  align:"left",
  column: [
    {
      label: "A卡卡号",
      prop: "cardNo",
      sortable: true,
      search:true,
      minWidth:130,
      overHidden:true,
    },
    {
      label: "激活时间",
      prop: "searchDate",
      sortable: true,
      type:"date",
      searchRange:true,
      search: true,
      hide:true,
      showColumn:false,
      valueFormat: 'yyyy-MM-dd',
    },
    {
      label: "状态",
      prop: "status",
      search:true,
      sortable: true,
      type:"select",
      dicData:[
         {
          label:"全部",
          value:"",
        },
        {
          label:"未激活",
          value:"1",
        },
        {
          label:"已激活",
          value:"2",
        },
        {
          label:"已结算",
          value:"3",
        },
        {
          label:"已作废",
          value:"9",
        },
      ],
      overHidden:true,
    },
    {
      label: "激活时间",
      prop: "bindingDate",
      sortable: true,
      type:"datetime",
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      minWidth:140,
      overHidden:true,
    },
   
    {
      label: "运单总数",
      prop: "waybillCount",
      sortable: true,
      minWidth:100,
      overHidden:true,
    },
    {
      label: "已交运单数",
      prop: "giveCardCount",
      minWidth:100,
      overHidden:true,
    },
    {
      label: "待结算金额",
      prop: "unsettledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已结算金额",
      prop: "settledAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
    {
      label: "已付款金额",
      prop: "paidAmount",
      sortable: true,
      minWidth:116,
      overHidden:true,
    },
  ],
};
